import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { getcommodity } from '../redux/commodity';

function Progress() {
  return <div>Loading...</div>;
}

export default function BasicModal(props) {
  const dt = new Date();
  const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
  const day = dt.getUTCDate();
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = dt.getFullYear();
  const date = year + "-" + month + "-" + day;

  const [open, setOpen] = React.useState(props.value);
  const [loading, setLoading] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
    props.setfalser();
  };

  const clearForm = () => {
    const fields = ['date', 'amount', 'barter', 'unit'];
    fields.forEach(field => {
      const element = document.getElementById(field);
      if (element) element.value = '';
    });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  const submitAction = async (data, successMessage) => {
    setLoading(true);
    try {
      const response = await axios.post("https://embert.sisrevolution.com/api/commodity/editcommodity/", data);
      if (response.status === 200) {
        setSnackbarMessage(successMessage);
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        dispatch(getcommodity({ data: response.data }));
        clearForm();
        handleClose();
      }
      setLoading(false);
    } catch (err) {
      setSnackbarMessage('Operation failed. Please try again.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setLoading(false);
      console.error(err);
    }
  };

  const approvec = () => {
    const addfarmer = () => {
      submitAction({ status: "Approved" }, 'Contract approved successfully!');
    };

    return (
      <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }} noValidate autoComplete="off">
        <p><b>All terms and conditions are met, approve contract</b></p>
        <TextField id="date" label="Date Approved" type="date" autoComplete="current-text" />
        <List sx={{ width: '100%' }}>
          <ListItem><ListItemText primary="Farmer" secondary="Farmer" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Input Requested" secondary="Input Requested" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Quantity" secondary="Quantity" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Payment Terms" secondary="Payment Terms" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Input distribution status" secondary="Input distribution status" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Date Issued" secondary="Date Issued" /></ListItem>
        </List>
        {loading ? (
          <Button variant="outlined" disabled>Loading...</Button>
        ) : (
          <Button variant="outlined" onClick={addfarmer}>Approve Contract</Button>
        )}
      </Box>
    );
  };

  const approver = () => {
    const addfarmer = () => {
      const data = {
        amountpaid: document.getElementById("amount").value,
        quantity: document.getElementById("date").value,
        status: "Paid",
        barter: document.getElementById("barter").value,
        unitpaid: document.getElementById("unit").value,
      };
      submitAction(data, 'Payment approved successfully!');
    };

    return (
      <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }} noValidate autoComplete="off">
        <p><b>Approve Payment</b></p>
        <TextField id="amount" label="Amount Paid" type="number" InputProps={{ startAdornment: <InputAdornment position="start">GHC</InputAdornment> }} autoComplete="current-text" />
        <TextField id="date" label="Date Paid" type="date" autoComplete="current-text" />
        <TextField id="barter" label="Quantity Returned (Barter)" type="number" InputProps={{ startAdornment: <InputAdornment position="start">GHC</InputAdornment> }} autoComplete="current-text" />
        <TextField id="unit" label="Measuring Unit" type="number" InputProps={{ startAdornment: <InputAdornment position="start">GHC</InputAdornment> }} autoComplete="current-text" />
        <List sx={{ width: '100%' }}>
          <ListItem><ListItemText primary="Farmer" secondary="Farmer" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Input Requested" secondary="Input Requested" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Quantity" secondary="Quantity" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Payment Terms" secondary="Payment Terms" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Input distribution status" secondary="Input distribution status" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Date Issued" secondary="Date Issued" /></ListItem>
        </List>
        <div align='center'>
          {loading ? (
            <Button variant="outlined" disabled>Loading...</Button>
          ) : (
            <Button variant="outlined" onClick={addfarmer}>Approve Payment</Button>
          )}
        </div>
      </Box>
    );
  };

  const closec = () => {
    const addfarmer = () => {
      submitAction({ status: "Closed" }, 'Contract closed successfully!');
    };

    return (
      <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }} noValidate autoComplete="off">
        <p><b>All terms and conditions are met, close contract</b></p>
        <List sx={{ width: '100%' }}>
          <ListItem><ListItemText primary="Farmer" secondary="Farmer" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Input Requested" secondary="Input Requested" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Quantity" secondary="Quantity" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Payment Terms" secondary="Payment Terms" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Input distribution status" secondary="Input distribution status" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Date Issued" secondary="Date Issued" /></ListItem>
        </List>
        {loading ? (
          <Button variant="outlined" disabled>Loading...</Button>
        ) : (
          <Button variant="outlined" onClick={addfarmer}>Close Contract</Button>
        )}
      </Box>
    );
  };

  const distributei = () => {
    const addfarmer = () => {
      submitAction({ status: "Distributed" }, 'Input issued successfully!');
    };

    return (
      <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }} noValidate autoComplete="off">
        <p><b>Issue input for distribution</b></p>
        <TextField id="date" label="Date Issued" type="date" autoComplete="current-text" />
        <List sx={{ width: '100%' }}>
          <ListItem><ListItemText primary="Farmer" secondary="Farmer" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Input Requested" secondary="Input Requested" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Quantity" secondary="Quantity" /></ListItem>
          <Divider />
          <ListItem><ListItemText primary="Payment Terms" secondary="Payment Terms" /></ListItem>
        </List>
        <div align='center'>
          {loading ? (
            <Button variant="outlined" disabled>Loading...</Button>
          ) : (
            <Button variant="outlined" onClick={addfarmer}>Issue Input</Button>
          )}
        </div>
      </Box>
    );
  };

  return (
    <div>
      <Dialog fullWidth minWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          {props.name}
          <IconButton onClick={handleClose} style={{ float: "right" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          {props.name === "Approve Contract" && approvec()}
          {props.name === "Approve Recovery / Payment" && approver()}
          {props.name === "Close Contract" && closec()}
          {props.name === "Distribute Input" && distributei()}
        </DialogContent>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}